import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { getEntity, updateEntity, createEntity, reset } from './kpi-last-processed.reducer';
import { IKpiLastProcessed } from 'app/shared/model/kpi-last-processed.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const KpiLastProcessedUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const kpiLastProcessedEntity = useAppSelector(state => state.kpiLastProcessed.entity);
  const loading = useAppSelector(state => state.kpiLastProcessed.loading);
  const updating = useAppSelector(state => state.kpiLastProcessed.updating);
  const updateSuccess = useAppSelector(state => state.kpiLastProcessed.updateSuccess);

  const handleClose = () => {
    props.history.push('/kpi-last-processed' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTruckImplements({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...kpiLastProcessedEntity,
      ...values,
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...kpiLastProcessedEntity,
          truckImplementId: kpiLastProcessedEntity?.truckImplement?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.kpiLastProcessed.home.createOrEditLabel" data-cy="KpiLastProcessedCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.kpiLastProcessed.home.createOrEditLabel">Create or edit a KpiLastProcessed</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="kpi-last-processed-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.kpiLastProcessed.sensorData')}
                id="kpi-last-processed-sensorData"
                name="sensorData"
                data-cy="sensorData"
                type="text"
              />
              <ValidatedField
                id="kpi-last-processed-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.kpiLastProcessed.truckImplement')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/kpi-last-processed" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default KpiLastProcessedUpdate;
